/** The independent coreBOS backend for the AI portal (in the flywheel LXD container). */
export const COREBOS_INSTANCE = 'ai-backend.evolutivo.ai';
export const COREBOS_WEBSERVICE_URL = 'https://ai-backend.evolutivo.ai/webservice.php';
export const coreBOSMap = {
    policy: {
        descriptor: 'policy',
        coreBOSModule: 'evPolicies',
        wsidPrefix: '73x',
        listView: ['title', 'policystatus', 'policy_type', 'policytoaccount', 'policyisactive', 'createdtime'],
        showView: [
            'title', 'policystatus', 'policy_type', 'policyisactive', 'effectivsince',
            'policyreviewdate', 'policyversion', 'policytoaccount', 'allow_upload', 'model',
            'assigned_user_id', 'createdtime', 'modifiedtime',
        ],
        editView: [
            'title', 'policystatus', 'policy_type', 'policyisactive', 'effectivsince',
            'policyreviewdate', 'policyversion', 'policytoaccount', 'allow_upload', 'model', 'description',
        ],
        createView: {
            fields: ['title', 'policystatus', 'policy_type', 'policyisactive', 'effectivsince', 'policytoaccount', 'assigned_user_id', 'description'],
            required: ['title'],
            defaults: { policystatus: 'Draft', policyisactive: '1' },
        },
        searchFields: ['title'],
    },
    acceptance: {
        descriptor: 'acceptance',
        coreBOSModule: 'evAcceptance',
        wsidPrefix: '77x',
        listView: ['acctitle', 'acceptance_status', 'acclastdate', 'acctopolicy', 'acceptancetocontent', 'pacclinktocontact', 'accmethod', 'assigned_user_id'],
        showView: [
            'acctitle', 'acceptance_status', 'acclastdate', 'accmethod', 'acclevelescal', 'email_opened',
            'acctopolicy', 'acceptancetocontent', 'pacclinktocontact', 'acctoemployee', 'contact_type',
            'evacceptance_no', 'description', 'assigned_user_id', 'createdtime', 'modifiedtime',
        ],
        editView: ['acctitle', 'acceptance_status', 'acclastdate', 'accmethod', 'acctopolicy', 'acceptancetocontent', 'pacclinktocontact', 'acctoemployee', 'contact_type', 'description'],
        createView: {
            fields: ['acctitle', 'acceptance_status', 'acclastdate', 'accmethod', 'acctopolicy', 'acceptancetocontent', 'pacclinktocontact', 'acctoemployee', 'contact_type', 'description'],
            required: ['acctitle'],
            defaults: { acceptance_status: 'Pending' },
        },
        searchFields: ['acctitle'],
    },
    content: {
        descriptor: 'content',
        coreBOSModule: 'cbContent',
        wsidPrefix: '85x',
        listView: ['title', 'position', 'page', 'contenttocontact', 'assigned_user_id', 'createdtime'],
        showView: ['title', 'position', 'page', 'contenttocontact', 'cbcontent_no', 'allow_upload', 'assigned_user_id', 'createdtime', 'modifiedtime'],
        editView: ['title', 'content', 'position', 'page', 'contenttocontact', 'allow_upload'],
        createView: {
            fields: ['title', 'content', 'position', 'page', 'contenttocontact', 'assigned_user_id'],
            required: ['title'],
            defaults: {},
        },
        searchFields: ['title'],
    },
    // ── New modules (Pass 1/2, 2026-08-22) ──────────────────────────────────
    // WSID prefixes assigned on creation: evUtenteAI=87x, evSistemaAI=88x,
    // evRichiestaAI=89x, evLabProject=90x, evPrompt=91x, evCorso=92x,
    // evAttestato=93x, evRevisioneSistema=94x, evVoceWiki=95x.
    ai_user: {
        descriptor: 'ai_user',
        coreBOSModule: 'evUtenteAI',
        wsidPrefix: '87x',
        listView: ['nome_upn', 'ruolo', 'unita_organizzativa', 'stato_utente', 'lingua'],
        showView: ['nome_upn', 'ruolo', 'unita_organizzativa', 'lingua', 'centro_di_costo', 'stato_utente', 'utente_id_pseudo', 'createdtime', 'modifiedtime'],
        editView: ['nome_upn', 'ruolo', 'unita_organizzativa', 'lingua', 'centro_di_costo', 'stato_utente'],
        createView: {
            fields: ['nome_upn', 'ruolo', 'unita_organizzativa', 'lingua', 'stato_utente'],
            required: ['nome_upn', 'ruolo', 'unita_organizzativa', 'lingua', 'stato_utente'],
            defaults: { stato_utente: 'Attivo', lingua: 'Italiano' },
        },
        searchFields: ['nome_upn'],
    },
    ai_system: {
        descriptor: 'ai_system',
        coreBOSModule: 'evSistemaAI',
        wsidPrefix: '88x',
        listView: ['nome_sistema', 'fornitore', 'categoria_rischio', 'stato_approvazione', 'prossima_revisione', 'owner_interno'],
        showView: [
            'nome_sistema', 'fornitore', 'dipartimento', 'owner_interno', 'categoria_rischio',
            'stato_approvazione', 'finalita_uso', 'prossima_revisione', 'ultima_interazione',
            'contatore_utilizzo', 'richiesta_origine', 'note', 'createdtime', 'modifiedtime',
        ],
        editView: ['nome_sistema', 'fornitore', 'dipartimento', 'owner_interno', 'categoria_rischio', 'stato_approvazione', 'finalita_uso', 'prossima_revisione', 'note'],
        createView: {
            fields: ['nome_sistema', 'fornitore', 'dipartimento', 'owner_interno', 'categoria_rischio', 'finalita_uso', 'prossima_revisione'],
            required: ['nome_sistema', 'fornitore', 'dipartimento', 'categoria_rischio', 'finalita_uso', 'prossima_revisione'],
            defaults: { stato_approvazione: 'In valutazione' },
        },
        searchFields: ['nome_sistema'],
    },
    ai_request: {
        descriptor: 'ai_request',
        coreBOSModule: 'evRichiestaAI',
        wsidPrefix: '89x',
        listView: ['titolo_richiesta', 'richiedente', 'stato_richiesta', 'categoria_rischio_proposta', 'createdtime'],
        showView: [
            'titolo_richiesta', 'richiedente', 'sistema_ai', 'finalita_uso', 'tipologia_dati',
            'utenti_previsti', 'durata_prevista', 'costo_stimato', 'valutazione_privacy',
            'categoria_rischio_proposta', 'stato_richiesta', 'createdtime', 'modifiedtime',
        ],
        editView: ['titolo_richiesta', 'richiedente', 'sistema_ai', 'finalita_uso', 'tipologia_dati', 'utenti_previsti', 'durata_prevista', 'costo_stimato', 'valutazione_privacy', 'categoria_rischio_proposta', 'stato_richiesta'],
        createView: {
            fields: ['titolo_richiesta', 'richiedente', 'finalita_uso', 'tipologia_dati', 'utenti_previsti', 'durata_prevista', 'valutazione_privacy', 'categoria_rischio_proposta'],
            required: ['titolo_richiesta', 'richiedente', 'finalita_uso', 'tipologia_dati', 'utenti_previsti', 'durata_prevista', 'valutazione_privacy', 'categoria_rischio_proposta'],
            defaults: { stato_richiesta: 'Bozza' },
        },
        searchFields: ['titolo_richiesta'],
    },
    ai_lab_project: {
        descriptor: 'ai_lab_project',
        coreBOSModule: 'evLabProject',
        wsidPrefix: '90x',
        listView: ['nome_progetto', 'tipo', 'stato_avanzamento', 'categoria_rischio', 'responsabile'],
        showView: ['nome_progetto', 'tipo', 'stato_avanzamento', 'categoria_rischio', 'responsabile', 'membri_abilitati', 'sistemi_ai_coinvolti', 'createdtime', 'modifiedtime'],
        editView: ['nome_progetto', 'tipo', 'stato_avanzamento', 'categoria_rischio', 'responsabile', 'membri_abilitati', 'sistemi_ai_coinvolti'],
        createView: {
            fields: ['nome_progetto', 'tipo', 'categoria_rischio', 'responsabile', 'membri_abilitati'],
            required: ['nome_progetto', 'tipo', 'categoria_rischio', 'responsabile', 'membri_abilitati'],
            defaults: { stato_avanzamento: 'Proposto' },
        },
        searchFields: ['nome_progetto'],
    },
    prompt: {
        descriptor: 'prompt',
        coreBOSModule: 'evPrompt',
        wsidPrefix: '91x',
        listView: ['titolo', 'autore', 'strumento_target', 'area', 'stato_prompt', 'voti'],
        showView: ['titolo', 'testo_prompt', 'strumento_target', 'area', 'autore', 'progetto_ai_lab', 'versione', 'stato_prompt', 'voti', 'createdtime', 'modifiedtime'],
        editView: ['titolo', 'testo_prompt', 'strumento_target', 'area', 'autore', 'progetto_ai_lab', 'stato_prompt'],
        createView: {
            fields: ['titolo', 'testo_prompt', 'strumento_target', 'area', 'autore'],
            required: ['titolo', 'testo_prompt'],
            defaults: { stato_prompt: 'Bozza' },
        },
        searchFields: ['titolo'],
    },
    course: {
        descriptor: 'course',
        coreBOSModule: 'evCorso',
        wsidPrefix: '92x',
        listView: ['titolo_corso', 'ruolo_area_destinataria', 'obbligatorio_art4', 'stato_corso', 'durata_stimata_min'],
        showView: ['titolo_corso', 'descrizione', 'contenuto', 'ruolo_area_destinataria', 'durata_stimata_min', 'obbligatorio_art4', 'stato_corso', 'createdtime', 'modifiedtime'],
        editView: ['titolo_corso', 'descrizione', 'contenuto', 'ruolo_area_destinataria', 'durata_stimata_min', 'obbligatorio_art4', 'stato_corso'],
        createView: {
            fields: ['titolo_corso', 'descrizione', 'contenuto', 'ruolo_area_destinataria', 'obbligatorio_art4'],
            required: ['titolo_corso', 'descrizione', 'contenuto', 'ruolo_area_destinataria', 'obbligatorio_art4'],
            defaults: { stato_corso: 'Bozza', obbligatorio_art4: '0' },
        },
        searchFields: ['titolo_corso'],
    },
    certificate: {
        descriptor: 'certificate',
        coreBOSModule: 'evAttestato',
        wsidPrefix: '93x',
        listView: ['codice_attestato', 'utente', 'corso', 'data_completamento', 'esito_attestato'],
        showView: ['codice_attestato', 'utente', 'corso', 'data_completamento', 'esito_attestato', 'punteggio', 'ente_certificatore', 'createdtime'],
        editView: ['data_completamento', 'esito_attestato', 'punteggio', 'ente_certificatore'],
        createView: {
            fields: ['corso', 'utente', 'data_completamento', 'esito_attestato', 'codice_attestato'],
            required: ['corso', 'utente', 'data_completamento', 'esito_attestato', 'codice_attestato'],
            defaults: { ente_certificatore: 'Evolutivo' },
        },
        searchFields: ['codice_attestato'],
    },
    ai_system_review: {
        descriptor: 'ai_system_review',
        coreBOSModule: 'evRevisioneSistema',
        wsidPrefix: '94x',
        listView: ['codice_revisione', 'sistema_ai', 'revisore', 'data_revisione', 'esito_revisione'],
        showView: ['codice_revisione', 'sistema_ai', 'revisore', 'data_revisione', 'esito_revisione', 'categoria_rischio_confermata', 'prossima_revisione', 'note', 'createdtime'],
        editView: ['sistema_ai', 'revisore', 'data_revisione', 'esito_revisione', 'categoria_rischio_confermata', 'prossima_revisione', 'note'],
        createView: {
            fields: ['sistema_ai', 'revisore', 'data_revisione', 'esito_revisione', 'categoria_rischio_confermata', 'prossima_revisione'],
            required: ['sistema_ai', 'revisore', 'data_revisione', 'esito_revisione', 'categoria_rischio_confermata', 'prossima_revisione'],
            defaults: {},
        },
        searchFields: ['codice_revisione'],
    },
    wiki_entry: {
        descriptor: 'wiki_entry',
        coreBOSModule: 'evVoceWiki',
        wsidPrefix: '95x',
        listView: ['titolo', 'unita_organizzativa', 'lingua', 'stato_voce', 'autore', 'utilita'],
        showView: ['titolo', 'corpo', 'unita_organizzativa', 'funzione', 'lingua', 'autore', 'stato_voce', 'utilita', 'createdtime', 'modifiedtime'],
        editView: ['titolo', 'corpo', 'unita_organizzativa', 'funzione', 'lingua', 'stato_voce'],
        createView: {
            fields: ['titolo', 'corpo', 'unita_organizzativa', 'lingua'],
            required: ['titolo', 'corpo', 'unita_organizzativa', 'lingua'],
            defaults: { stato_voce: 'Bozza' },
        },
        searchFields: ['titolo'],
    },
};
